module.exports = __webpack_public_path__ + "static/media/FigmaAccountSetting.2b805c79.png";